import { Component, OnInit } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, Subscription, Observable } from 'rxjs';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import moment from 'moment';


@Component({
    selector: 'app-token-appt-qms',
    templateUrl: './token-appt-qms.component.html',
    styleUrls: ['./token-appt-qms.component.scss'],
    standalone: false
})
export class TokenApptQmsComponent implements OnInit {
  screen_data: any;
  doctorList = []
  screen: any; bg_profile_path: any = "/dms/api/v1/orgImage/image-response-entity?args=id:";
  haSubscription: Subscription;
  subscription: Subscription;
  myInterval = 1500;
  activeSlideIndex = 0;
  showIndicator: boolean = false
  page_no: number = -1
  totalCount: any
  public route: Router
  doctorprofileDetails: any;
  _moment = moment;
  constructor(
    private baseService: BaseService,
    private alert: AlertsService,
    private Aroute: ActivatedRoute,
    private loader: LoaderService,
    private appService: AppService,
  ) { }

  ngOnInit(): void {
    this.Aroute.params.subscribe((res: any) => {
      // this.getRefershTime(res.id);
      if (res && res.id)
        this.getScreenData(decodeURIComponent(res.id));
    })
  }

  hasBackgroundcolor() {
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = "0";
    hasColor.style.width = "100%";
    document.getElementsByTagName("body")[0].style.backgroundImage = this.screen_data && this.screen_data.bg_color_code ? `linear-gradient(${this.screen_data.bg_color_code},${this.screen_data.bg_color_code})` : "linear-gradient(rgb(21, 59, 127), rgb(21, 59, 127))";
    let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    hasDisplay.style.display = "none"
  }


  getScreenData(id: any) {
    this.getScreenRefreshRate$(id).subscribe((data: any) => {
      this.screen_data = data.resource.map(x => { return { ...x, bg_profile_path: x.title_image_id ? this.bg_profile_path + x.title_image_id : '' } })[0];
      this.hasBackgroundcolor();
      this.getDoctorList();
      const source = interval(parseInt(data.resource[0].refresh_rate) * 1000);
      //  this.myInterval = JSON.parse(data.resource[0].refresh_rate) * 1000;
      this.haSubscription = source.subscribe(val => this.getDoctorList());
    })
  }
  ngAfterViewInit() {
    setTimeout(function () {
      let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
      hideSidebar.style.display = "none";
    }, 5)
  }

  calculateStyles(_hasLength: any) {
    return { 'width': (94 / _hasLength) + "%" }
  }

  getDoctorList() {
    this.totalCount != undefined ? this.page_no = this.page_no + 1 : this.page_no = 0;
    var obj = {
      page_size: 15,
      page_no: this.page_no,
      args: "service_date:" + this._moment().startOf('day').valueOf() + ",noCount:1"
    }
    if (this.appService.getUniversalConfig("multi_care_type")) {
      obj.args += ",care_type:" + this.appService.getDynamicFunctions("getCurrentCareType")
    }
    if (obj.page_no > Math.round(this.totalCount / obj.page_size)) {
      obj.page_no = 0
    }
    this.baseService.getData(obj, '', "queue_desk_mapping", "queue-management", "GET_APPOINTMENT_SERVING_TOKEN").subscribe((res: any) => {
      if (res.errCode == 0 && res.resource.length > 0) {
        this.totalCount = res.resource.length //count
        res.resource.sort((a, b) => (a.speciality_name || '').localeCompare(b.speciality_name || ''));
        res.resource.sort((a, b) => (a.desk_user_name || '').localeCompare(b.desk_user_name || ''));
        this.doctorList = res.resource
        //   this.getModifytoken(res.resource)
      } else if (res.errCode == -1) {
        this.alert.error(res.message);
      }
    })
  }

  onSlideChange(event: any) {
    if (event == undefined) {
      this.activeSlideIndex = 0;
    } else {
      this.activeSlideIndex = event;
    }
  }

  // getModifytoken(token, callBack?) {
  //   let doctorList = []
  //   token.filter(data => {
  //     this.getProfileData(data.desk_user_id, cb => {
  //       if (cb != undefined && cb) {
  //         let obj =
  //         {
  //           "id": data.id,
  //           "profile_path": cb.path,
  //           "token": data.token,
  //           "treatingDoctorName": data.desk_user_name,
  //           "serviceRequestId": data.itemName,
  //           "treatingDoctorId": data.desk_user_id,
  //           "stage": data.stage,
  //           "status": data.status,
  //           "department_name": data.department_name,
  //           "department_id": data.department_id,
  //           "speciality": data.speciality,
  //           "speciality_id": data.speciality_id,
  //           "subDepartment_id": data.subDepartment_id,
  //           "subDepartment_name": data.subDepartment_name,
  //           "room_name": data.room_name,
  //         }
  //         doctorList.push(obj)
  //       }
  //     })
  //   })
  //   this.doctorList = doctorList
  // }

  //
  getScreenRefreshRate$(screen_number: any): Observable<any> {
    return this.baseService.get("GET_PAGE", "", "screen_master", "facility-management", "screen_number:" + screen_number)
  }

  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
    this.haSubscription && this.haSubscription.unsubscribe();
    let showbody: HTMLElement = document.getElementsByTagName("body")[0] as HTMLElement
    showbody.style.background = "";
    let hasColor: HTMLElement = document.getElementsByClassName("main")[0] as HTMLElement
    hasColor.style.margin = null;
    hasColor.style.width = null;
    let hasDisplay: HTMLElement = document.getElementsByTagName("app-header")[0] as HTMLElement
    hasDisplay.style.removeProperty("display");
    let hideSidebar: HTMLElement = document.getElementsByTagName("app-sidebar")[0] as HTMLElement;
    hideSidebar.style.removeProperty("display");
  }


  goBack() {
    window.history.back();
  }



  // getProfileData(doctor_id?, callBack?) {
  //   let args = 'doctor_id:' + doctor_id
  //   this.baseService.get("GET_DOCTOR_PROFILE_ID", args, "practitioner_facility_details", 'facility-management').subscribe(
  //     (data: any) => {
  //       if (data.resource != undefined && data.resource.length > 0 && data.resource[0].extra_data.path && data.errCode !== -1) {
  //         callBack(data.resource[0].extra_data)
  //       }
  //       else if (data.resource != undefined && data.resource.length > 0 && data.errCode !== -1) {
  //         callBack(data.resource[0].extra_data)
  //       }
  //       else {
  //         this.alert.error(data.message)
  //       }
  //     }
  //   );
  // }
}
